<p-card [header]="mandant.id ? ('MANDANTS.EDIT_MANDANT' | translate: mandant) : ('MANDANTS.ADD_MANDANT' | translate)">
  <form (ngSubmit)="onSubmit()" [formGroup]="form" novalidate>
    <div class="grid grid-cols-12">
      <app-form-text-input [form]="form" [twoColumns]="true" id="bezeichnung" label="GLOBAL.NAME"></app-form-text-input>
      <app-form-text-input [form]="form" [twoColumns]="true" id="acronym" label="GLOBAL.ACRONYM"></app-form-text-input>
      <app-form-text-input
        [form]="form"
        [twoColumns]="true"
        id="strasse"
        label="MANDANTS.STRASSE"></app-form-text-input>
      <app-form-text-input
        [form]="form"
        [twoColumns]="true"
        id="adressZusatz"
        label="MANDANTS.ADRESSZUSATZ"></app-form-text-input>
      <app-form-text-input [form]="form" [twoColumns]="true" id="plz" label="MANDANTS.PLZ"></app-form-text-input>
      <app-form-text-input [form]="form" [twoColumns]="true" id="ort" label="MANDANTS.ORT"></app-form-text-input>
      <app-form-dropdown
        [form]="form"
        [options]="countryOptions"
        [twoColumns]="true"
        id="land"
        label="MANDANTS.LAND"></app-form-dropdown>
      <app-form-dropdown
        [form]="form"
        [options]="kantonOptions"
        [twoColumns]="true"
        id="kantonId"
        label="MANDANTS.KANTON"></app-form-dropdown>
      <app-form-text-input
        [form]="form"
        [twoColumns]="true"
        id="telefon"
        label="MANDANTS.TELEFON"></app-form-text-input>
      <app-form-dropdown
        [form]="form"
        [options]="auswertungsbasisOptions"
        [twoColumns]="true"
        id="auswertungsbasis"
        label="MANDANTS.AUSWERTUNGSBASIS"></app-form-dropdown>
      <app-form-date-input
        [form]="form"
        [twoColumns]="true"
        id="benchmarkAb"
        label="MANDANTS.BENCHMARK_AB"></app-form-date-input>
      <app-form-multiselect
        [form]="form"
        [options]="languageOptions"
        [twoColumns]="true"
        id="languageCodes"
        label="MANDANTS.LANGUAGES"></app-form-multiselect>
      <app-form-date-input
        [form]="form"
        [twoColumns]="true"
        id="gueltigAb"
        label="GLOBAL.GUELTIG_AB"></app-form-date-input>
      <app-form-date-input
        [form]="form"
        [twoColumns]="true"
        id="gueltigBis"
        label="GLOBAL.GUELTIG_BIS"></app-form-date-input>

      <app-form-multiselect
        (onChange)="onChange()"
        [form]="form"
        [options]="marktOptions"
        [twoColumns]="true"
        id="marktIds"
        label="MANDANTS.MARKTS"></app-form-multiselect>

      <app-form-time-period
        [form]="form"
        [options]="tacsCodeKreisOptions"
        [withoutGap]="true"
        id="kategorieSets"
        label="MANDANTS.KATEGORIE_SETS"></app-form-time-period>

      <div class="col-span-12">
        <app-form-element id="logo" label="MANDANTS.LOGO">
          <p-fileUpload
            (uploadHandler)="upload($event)"
            [auto]="true"
            [chooseLabel]="'MANDANTS.CHOOSE_LOGO' | translate"
            [customUpload]="true"
            #fileUpload
            mode="basic"></p-fileUpload>
          @if (logo) {
            <img class="logo" src="data:image/jpg;base64,{{ logo }}" />
          }
        </app-form-element>
      </div>

      <app-form-text-input
        [form]="form"
        [twoColumns]="true"
        id="tacsRecordingUrl"
        label="ANWENDERBETRIEBE.TACS_RECORDING_URL"></app-form-text-input>

      <app-form-button-bar [form]="form" [saveDisabled]="submitting"></app-form-button-bar>
    </div>
  </form>
</p-card>
